import { html } from 'lit';
import { nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { consentTemplate, consentTemplateOverview } from './consent.tmpl';
import { replaceTooltips } from './util';
import comsStore from '../../state/ComsStore';
function getGroupText(textGroup) {
    return textGroup.text
        ? html ` ${unsafeHTML(replaceTooltips(textGroup.text))} `
        : nothing;
}
// start oneclick checkbox, text and container
function getOneclickHeader(oGroup) {
    var _a, _b;
    return html `
    <div class="form-group-checkbox">
      <input
        .checked=${oGroup.areAllConsentsAndFeaturesGranted}
        id="group-${oGroup.id}"
        type="checkbox"
        @click=${() => oGroup.oneClickToggle()}
        ?disabled="${(_b = (_a = comsStore.identity) === null || _a === void 0 ? void 0 : _a.readonly) !== null && _b !== void 0 ? _b : false}"/>
      <label for="group-${oGroup.id}">
        ${unsafeHTML(replaceTooltips(oGroup.text))}
      </label>
    </div>
  `;
}
function getGroupOneclickConsentsContainer(containerGroup) {
    var _a, _b;
    return html `
    <tef-coms-collapsible
      once
      ?is-open="${containerGroup.collapsibleOpen}"
      cloak
      context=${(_b = (_a = comsStore.config) === null || _a === void 0 ? void 0 : _a.styleContext) !== null && _b !== void 0 ? _b : ''}
      id=${containerGroup.name || 'noname'}
    >
      <div slot="title">
        ${containerGroup.oneclickCollapsible /* eslint-disable @typescript-eslint/indent */
        ? unsafeHTML(containerGroup.oneclickCollapsible)
        : 'Wenn ich einzelne Kontaktkanäle und Verarbeitungsvorgänge von meiner '
            + 'Auswahl ausschließen möchte, kann ich hier gesonderte Einwilligungen erteilen.'
    /* eslint-enable @typescript-eslint/indent */ }
      </div>
      <div slot="content">
        ${containerGroup.consents.map((consent) => consentTemplate(consent))}
      </div>
    </tef-coms-collapsible>
  `;
}
// end oneclick text and container
// denyAll - OCW checkbox
function getWithdrawal(ocwGroup) {
    if (!ocwGroup.denyall || ocwGroup.oneclick) {
        return nothing;
    }
    const checkboxId = `deny_check_${ocwGroup.id}`;
    return html `
    <div class="form-row">
      <div class="form-group-checkbox">
        <input
          id=${checkboxId}
          type="checkbox"
          .checked=${ocwGroup.areAllConsentsDenied}
          @click=${() => ocwGroup.denyAll()}
        />
        <label for=${checkboxId}>
          ${unsafeHTML(ocwGroup.denyall)}
        </label>
      </div>
    </div>
  `;
}
export const groupTemplate = (group) => html `
  <div class="section">
    <h4 class="typography-display--4">
      ${unsafeHTML(replaceTooltips(group.header))}
    </h4>
    <p>
      ${group.oneclick /* eslint-disable @typescript-eslint/indent */
    ? getOneclickHeader(group)
    : getGroupText(group)
/* eslint-enable @typescript-eslint/indent */ }
    </p>
    <div>
      ${group.oneclick /* eslint-disable @typescript-eslint/indent */
    ? getGroupOneclickConsentsContainer(group)
    : group.consents.map((consent) => consentTemplate(consent))
/* eslint-enable @typescript-eslint/indent */ }
    </div>
    ${group.footer ? html `
      <p>
        ${unsafeHTML(replaceTooltips(group.footer))}
      </p>
    ` : nothing}
    ${getWithdrawal(group)}
  </div>
  <hr class="divider" />
`;
export const groupTemplateOverview = (group) => {
    var _a;
    const filteredConsents = group.consents
        .filter(({ granted = false }) => granted === true);
    return html `
    <div class="section">
      <h4 class="typography-display--4">
        ${unsafeHTML(replaceTooltips(group.header))}
      </h4>
      <div>
        ${(filteredConsents.length === 0) /* eslint-disable @typescript-eslint/indent */
        ? html `
            <div class="coms-ocw">
              ${(_a = group.denyallView) !== null && _a !== void 0 ? _a : 'es liegen keine Erlaubnisse / Einwilligungen vor'}
            </div>`
        : html `
            <div class="container-fluid">
              ${group.consents.map((consent) => (consent.granted ? consentTemplateOverview(consent) : nothing))}
            </div>`
    /* eslint-enable @typescript-eslint/indent */ }
      </div>
    </div>
    <hr class="divider" />
  `;
};
//# sourceMappingURL=group.tmpl.js.map